import React from 'react';
import { SectionHeader } from '../../../ui/molecules/SectionHeader';

type AboutSectionProps = {
  about: string;
};

export function AboutSection({ about }: AboutSectionProps) {
  return (
    <section
      id="about"
      className="px-4 py-16 bg-white dark:bg-stone-900"
      aria-labelledby="about-heading"
    >
      <div className="mx-auto max-w-4xl">
        <SectionHeader
          id="about-heading"
          title="About"
          subtitle="Hi Guys!"
        />
        <p className="max-w-2xl text-stone-600 leading-relaxed dark:text-stone-400">{about}</p>
      </div>
    </section>
  );
}
